<template>
  <div>
    <span v-if="winnerAudience">
      {{I18n.t(`live_auctions.${auction.lastBidType}`)}}
    </span>
    <span v-else>
      {{this.auction.winner.firstname}} {{this.auction.winner.lastname}}
      {{this.auction.winner.email}}
      {{this.auction.winner.phone}}
      {{this.auction.winner.city}}
      <span v-if="winnerPhone">
        ({{I18n.t(`live_auctions.via_phone`)}})
      </span>
    </span>
  </div>
</template>

<script>
  import { BID_AUDIENCE, BID_PHONE } from './../../consts';

  export default {
    name: 'AuctionWinner',
    props: {
      auction: Object,
    },
    computed: {
      winnerAudience() {
        return this.auction.lastBidType === BID_AUDIENCE;
      },
      winnerPhone() {
        return this.auction.lastBidType === BID_PHONE;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/auction_winner.vue?ee8445fe